import Image from 'next/image';
import React from 'react';

const LlmsProductionReadySolutions = () => {
    return (
        <div
            className="section-py dark:text-light border-b"
            style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <h2 className="mb-[10px] dark:text-white"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            From Scattered Knowledge to Smart Business Decisions: Production-Ready Enterprise LLM and RAG
                            Solutions
                        </h2>
                        <p className="mb-[10px] dark:text-[#D7DEE5]"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Today, enterprises are no longer asking if they should adopt AI, but how fast they can do it safely
                            and effectively. We build RAG and LLM-based chatbots, autonomous agents, and secure MCP(Model Context
                            Protocol)-integrated systems that deliver real business outcomes while maintaining total control and
                            transparency. With our proven frameworks, your organization can leverage AI for faster
                            decision-making, smarter customer engagement, and scalable operational efficiency.
                        </p>
                        <p className="dark:text-[#D7DEE5]"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            We bridge the gap between experimentation and enterprise-grade deployment, crafting solutions that
                            move from innovation to impact.
                        </p>
                    </div>
                    <div className="lg:col-span-6">
                        <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-2 gap-7 mb-7">
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/llms-aiml/svg/ic_productionreadychatbots.svg"
                                        width={36}
                                        height={36}
                                        alt="Production-ready chatbots"
                                    />
                                </div>

                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Production-ready chatbots, RAG pipelines, and voice assistants with Natural Language
                                    Processing (NLP) from fast POCs to low-risk production
                                </p>
                            </div>
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/llms-aiml/svg/ic_tailoredconversation.svg"
                                        width={36}
                                        height={36}
                                        alt="Tailored conversational workflows"
                                    />
                                </div>

                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Tailored conversational workflows with enterprise-grade security and MCP integrations
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-2 gap-7">
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/llms-aiml/svg/ic_automatedknowledge.svg"
                                        width={36}
                                        height={36}
                                        alt="Automated knowledge discovery"
                                    />
                                </div>
                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Automated knowledge discovery through contextual retrieval and semantic search
                                </p>
                            </div>
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/llms-aiml/svg/ic_measurable_business.svg"
                                        width={36}
                                        height={36}
                                        alt="Measurable business ROI"
                                    />
                                </div>
                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Measurable business ROI with reduced response time and improved customer satisfaction
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LlmsProductionReadySolutions;
